// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ActionType } from '../tbs/action-type.js';


export class KickPlayerSlotAction implements flatbuffers.IUnpackableObject<KickPlayerSlotActionT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):KickPlayerSlotAction {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsKickPlayerSlotAction(bb:flatbuffers.ByteBuffer, obj?:KickPlayerSlotAction):KickPlayerSlotAction {
  return (obj || new KickPlayerSlotAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsKickPlayerSlotAction(bb:flatbuffers.ByteBuffer, obj?:KickPlayerSlotAction):KickPlayerSlotAction {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new KickPlayerSlotAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

type():ActionType {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : ActionType.LobbyKickPlayerSlot;
}

playerId():number {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0;
}

static startKickPlayerSlotAction(builder:flatbuffers.Builder) {
  builder.startObject(2);
}

static addType(builder:flatbuffers.Builder, type:ActionType) {
  builder.addFieldInt16(0, type, ActionType.LobbyKickPlayerSlot);
}

static addPlayerId(builder:flatbuffers.Builder, playerId:number) {
  builder.addFieldInt16(1, playerId, 0);
}

static endKickPlayerSlotAction(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createKickPlayerSlotAction(builder:flatbuffers.Builder, type:ActionType, playerId:number):flatbuffers.Offset {
  KickPlayerSlotAction.startKickPlayerSlotAction(builder);
  KickPlayerSlotAction.addType(builder, type);
  KickPlayerSlotAction.addPlayerId(builder, playerId);
  return KickPlayerSlotAction.endKickPlayerSlotAction(builder);
}

unpack(): KickPlayerSlotActionT {
  return new KickPlayerSlotActionT(
    this.type(),
    this.playerId()
  );
}


unpackTo(_o: KickPlayerSlotActionT): void {
  _o.type = this.type();
  _o.playerId = this.playerId();
}
}

export class KickPlayerSlotActionT implements flatbuffers.IGeneratedObject {
constructor(
  public type: ActionType = ActionType.LobbyKickPlayerSlot,
  public playerId: number = 0
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  return KickPlayerSlotAction.createKickPlayerSlotAction(builder,
    this.type,
    this.playerId
  );
}
}
